"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_ERROR_CODES = exports.InternalServerError = exports.UnauthorizedError = exports.NotFoundError = exports.ForbiddenError = exports.ArgumentError = exports.CustomError = void 0;
class CustomError extends Error {
    constructor(customErrorObject) {
        super();
        this.customErrorObject = customErrorObject;
    }
}
exports.CustomError = CustomError;
class ArgumentError extends CustomError {
    constructor(parameter, message, customErrorObject) {
        super(customErrorObject);
        this.statusCode = 400;
        this.parameter = parameter;
        this.message = message;
    }
}
exports.ArgumentError = ArgumentError;
class ForbiddenError extends Error {
    constructor(message) {
        super();
        this.statusCode = 403;
        this.message = message || 'Invalid authToken. unauthorized';
    }
}
exports.ForbiddenError = ForbiddenError;
class NotFoundError extends Error {
    constructor(itemName, message) {
        super();
        this.statusCode = 404;
        this.itemName = itemName;
        this.message = message || '';
    }
}
exports.NotFoundError = NotFoundError;
class UnauthorizedError extends Error {
    constructor(parameter, message) {
        super();
        this.statusCode = 401;
        this.parameter = parameter;
        this.message = message;
    }
}
exports.UnauthorizedError = UnauthorizedError;
class InternalServerError extends Error {
    constructor(parameter) {
        super();
        this.statusCode = 500;
        this.parameter = parameter;
        this.message = 'There was an internal server error. Please contact support for assistance.';
    }
}
exports.InternalServerError = InternalServerError;
var CUSTOM_ERROR_CODES;
(function (CUSTOM_ERROR_CODES) {
    CUSTOM_ERROR_CODES[CUSTOM_ERROR_CODES["DUPLICATE_RECORDS"] = 1062] = "DUPLICATE_RECORDS";
})(CUSTOM_ERROR_CODES || (exports.CUSTOM_ERROR_CODES = CUSTOM_ERROR_CODES = {}));
//# sourceMappingURL=Error.js.map